import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core';
import { TranslationService } from './shared/modules/i18n';
// language list
import { locale as enLang } from './shared/modules/i18n/vocabs/en';
import { locale as chLang } from './shared/modules/i18n/vocabs/ch';
import { locale as esLang } from './shared/modules/i18n/vocabs/es';
import { locale as jpLang } from './shared/modules/i18n/vocabs/jp';
import { locale as deLang } from './shared/modules/i18n/vocabs/de';
import { locale as frLang } from './shared/modules/i18n/vocabs/fr';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { AuthService } from './shared/services/auth.service';
import { Router } from '@angular/router';
import { AccesilityService } from './shared/services/accesibility.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
    //Por el momento usado unicamente por accesibilidad
    private subs: Subscription[] = [];
    public hideAccessibility = false;

    constructor(private authService: AuthService, private translationService: TranslationService, private router: Router, private keycloakService: KeycloakService, private accesibilityService: AccesilityService) {
        // register translations
        this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
        /**
         * Funcion encargada de capturar el evento de vencimiento de token
         * Una vez entra intenta actualizar el token con el refresh token las veces necesarias hasta que la sesion finalice o el tiempo maximo llegue a su limite.
         */
        keycloakService.keycloakEvents$.subscribe({
            next: (e) => {
                if (e.type == KeycloakEventType.OnTokenExpired) {
                    keycloakService
                        .updateToken(environment.UPDATE_TOKEN_TIME)
                        .then(function (refreshed) {
                            /*if (refreshed) {
                                console.log('Token was successfully refreshed');
                            } else {
                                console.log('Token is still valid');
                            }*/
                        })
                        .catch(function () {
                            console.log('Failed to refresh the token, or the session has expired');
                        });
                }
            },
        });

        //Ocultar el menu de accesibilidad en el modulo de administración
        this.router.events.subscribe(() => {
            this.hideAccessibility = this.router.url.startsWith('/admin');
        });
    }
}
// @HostListener('window:beforeunload', ['$event'])
// unloadNotification($event: any): void {
//     console.log('archivo: app.component.ts, linea: 41, elemento: $event, valor: ', $event);
//     this.router.navigate(['/']);
//     this.authService.logout();
// }
